/**
 * Generato automaticamente.
 * framework-cmp-procedimenti
 */

export type GetBackNotifichePriorita =
  (typeof GetBackNotifichePriorita)[keyof typeof GetBackNotifichePriorita];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBackNotifichePriorita = {
  BASSA: 'BASSA',
  NORMALE: 'NORMALE',
  ALTA: 'ALTA',
  URGENTE: 'URGENTE',
} as const;
